import React from "react";
import { BrowserRouter, Route } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import theme from "nekrasovka-ui/theme";

import Layout from "containers/Layout";
import Curators from "components/Curators";
import SearchResult from "containers/SearchResult";
import PersonPage from "containers/PersonPage";
import PersonsPage from "containers/PersonsPage";

export default () => (
  <ThemeProvider theme={theme}>
    <BrowserRouter>
      <Layout>
        <Route path="/" exact component={Curators} />
        <Route path="/search" component={SearchResult} />
        <Route path="/persons" component={PersonsPage} />
        <Route path="/person/:id" component={PersonPage} />
      </Layout>
    </BrowserRouter>
  </ThemeProvider>
);



// WEBPACK FOOTER //
// ./src/containers/App.js